<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12" id="printMe">
                <div class="card">
                    <div class="card-header border-bottom">
                        <div class="d-md-flex align-items-center m-t-20">
                            <div class="d-flex align-items-center">
                                <div>
                                    <h4 class="card-title">{{delivery_note.number}} </h4>
                                    <h6 class="text-muted m-t-5">{{delivery_note.created_at | date}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="printableArea card-body">
                        <div class="row">
                            <div class="col-md-6" v-if="delivery_note.from_warehouse">
                                <h5 class="font-bold text-muted">From</h5>
                                <h4 class="m-t-5">{{delivery_note.from_warehouse.name}}</h4>
                                <p class="text-normal">
                                    {{delivery_note.from_warehouse.line1}}, &nbsp;{{delivery_note.from_warehouse.line2}}<br>
                                    {{delivery_note.from_warehouse.country}},&nbsp;{{delivery_note.from_warehouse.city}}<br>
                                    {{delivery_note.from_warehouse.state}},&nbsp;{{delivery_note.from_warehouse.postal_code}}<br>
                                </p>
                            </div>

                            <div class="col-md-6" v-if="delivery_note.to_warehouse">
                                <h5 class="font-bold text-muted">To</h5>
                                <h4 class="m-t-5">{{delivery_note.to_warehouse.name}}</h4>
                                <p class="text-normal">
                                    {{delivery_note.to_warehouse.line1}}, &nbsp;{{delivery_note.to_warehouse.line2}}<br>
                                    {{delivery_note.to_warehouse.country}},&nbsp;{{delivery_note.to_warehouse.city}}<br>
                                    {{delivery_note.to_warehouse.state}},&nbsp;{{delivery_note.to_warehouse.postal_code}}<br>
                                </p>
                            </div>
                        </div>
                        <div class="row m-t-20">
                            <div class="col-md-12">
                                <h5 class="font-bold text-muted">Item</h5>
                            </div>
                            <div class="col-md-12 m-t-5 " v-if="delivery_note.commodity">
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-bordered font-10" style="font-size: small;">
                                        <thead class="text-center">
                                        <tr>
                                            <th class="p-1 font-weight-bold">Name</th>
                                            <th class="p-1 font-weight-bold">Quantity</th>
                                            <th class="p-1 font-weight-bold" v-if="delivery_note.commodity.hs_code">HS Code</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td class="p-1 text-center">{{delivery_note.commodity.name}} <span v-if="delivery_note.commodity.variety">-</span>
                                                {{delivery_note.commodity.variety}}
                                            </td>
                                            <td class="p-1 text-center">{{delivery_note.quantity| units}}</td>
                                            <td class="p-1 text-center" v-if="delivery_note.commodity.hs_code">{{delivery_note.commodity.hs_code}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row m-t-10">
                            <div class="col-md-12">
                                <h5 class="font-bold text-muted">Associated Batches</h5>
                            </div>
                            <div class="col-md-12 m-t-5 " v-if="delivery_note.batches.length>0">
                                <ul>
                                    <li v-for="batch in delivery_note.batches">{{batch}}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="row m-t-30">
                            <div class="col-md-12">
                                <b>Remarks :</b>
                                <p>{{delivery_note.comments || 'N/A'}}</p>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="card-footer text-right d-print-none">
                        <div class="button-group">
                            <button @click="printInvoice" class="btn btn-info">Print</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import GoodsServicesCategory from "../../../express/purchases/goods-services/GoodsServicesCategory";

    export default {
        name: "ViewDeliveryNote",
        components: {GoodsServicesCategory},
        props: ["deliverynoteid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                delivery_note: {
                    from_warehouse: null,
                    to_warehouse: null,
                    quantity: null,
                    commodity: null,
                    batches: null,
                    number: null,
                    created_at: null,
                    comments: null
                }
            }
        },
        mounted() {
            this.getDeliveryNote();
        },
        methods: {
            async getDeliveryNote() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/deliverynotes/${this.deliverynoteid}`);
                    this.delivery_note = data;
                } catch (e) {
                    this.$toastr('error', 'Delivery Note fetch failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            printInvoice() {
                this.$htmlToPaper('printMe');
            }
        }
    }
</script>

<style scoped>

</style>
